import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Button, Row, Col } from 'react-bootstrap';
import { login } from '../actions/auth';
import { toastSnackbar } from '../actions/toast';
import { FormValidator } from '../helpers/form-validator';
import { BarLoader } from '../components/widgets';
import { clearSession, getLoginStatus, setLoginStatus, getLogoutMessage } from '../helpers/session';
import logo from '../../assets/images/login-logo.png';
import '../../assets/scss/login.scss';
import GoogleLogin from './Oauth/GoogleLogin';
//import FacebookLogin from './Oauth/FacebookLogin';
import MicrosoftLogin from './Oauth/MicrosoftLogin';
import AppleLogin from './Oauth/AppleLogin';

class Login extends React.Component {
    constructor() {
        super();

        this.submitted = false;
        this.validator = new FormValidator([{
            field: 'username',
            method: 'isEmpty',
            validWhen: false,
            message: 'Username is required.'
        }, {
            field: 'password',
            method: 'isEmpty',
            validWhen: false,
            message: 'Password is required.'
        }]);

        this.state = {
            validation: this.validator.valid(),
            username: '',
            password: '',
        }

        this.handleChange = this.handleChange.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
    }

    componentDidMount() {
        const logoutMessage = getLogoutMessage();
        const loginStatus = getLoginStatus();
        if (logoutMessage) this.props.actions.toastSnackbar(logoutMessage, { autoClose: false });
        clearSession();
        setLoginStatus(loginStatus);
        this.refs.username.focus();
    }

    handleChange(event) {
        const { name, value } = event.target;
        this.setState({ [name]: value });
    }

    onSubmit(e) {
        e.preventDefault();

        const validation = this.validator.validate(this.state);
        this.setState({ validation });
        this.submitted = true;

        if (validation.isValid) {
            const param = { login: this.state.username, password: this.state.password };
            this.props.actions.login(param, this.props.history);
        }
    }

    render() {
        const validation = this.submitted ? this.validator.validate(this.state) : this.state.validation;

        return (
            <div className="limiter">
                <div className="container-login">
                    <div className="wrap-login">
                        {this.props.isRequest && <BarLoader />}
                        <form className="login-form validate-form" onSubmit={this.onSubmit}>
                            <span className="login-form-logo">
                                <img src={logo} alt="" />
                            </span>
                            <div className={`wrap-input validate-input ${validation.username.isInvalid ? 'alert-validate' : ''}`} data-validate={validation.username.message}>
                                <input className="input" type="text" ref="username" name="username" autoComplete="off" placeholder="Username" onChange={this.handleChange} />
                                <span className="focus-input" data-placeholder="&#xf207;"></span>
                            </div>

                            <div className={`wrap-input validate-input ${validation.password.isInvalid ? 'alert-validate' : ''}`} data-validate={validation.password.message}>
                                <input className="input" type="password" name="password" autoComplete="off" placeholder="Password" onChange={this.handleChange} />
                                <span className="focus-input" data-placeholder="&#xf191;"></span>
                            </div>

                            <div className="contact-form-checkbox" style={{ display: 'none' }}>
                                <input className="input-checkbox" id="ckb1" type="checkbox" name="remember-me" />
                                <label className="label-checkbox" htmlFor="ckb1">
                                    Remember me
                                </label>
                            </div>

                            <div className="container-login-form-btn">
                                <Button variant="primary" type="submit" className="btn-login"
                                    disabled={this.props.isRequest}>Sign in</Button>
                            </div>

                            <Row className="login-or">
                                <Col className="m-auto">
                                    <div className="splitter" />
                                </Col>
                                <div>OR</div>
                                <Col className="m-auto">
                                    <div className="splitter" />
                                </Col>
                            </Row>

                            <GoogleLogin history={this.props.history} />
                           {/*  <FacebookLogin history={this.props.history} /> */}
                            <MicrosoftLogin history={this.props.history} />
                            <AppleLogin history={this.props.history} />

                            <div className="text-center forgot-pwd">
                                <a className="txt1" href="#/" style={{ display: 'none' }}>
                                    Forgot Password?
                                </a>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        )
    }
}

const mapDispatchToProps = dispatch =>
    ({ actions: bindActionCreators({ login, toastSnackbar }, dispatch) });

const mapStateToProps = state => ({ isRequest: state.auth.isRequest });

export default connect(mapStateToProps, mapDispatchToProps)(Login);